<template>
  <div class="page-content" style="margin: 0px; width: 100%">
    <PageHeader></PageHeader>
    <Main
        v-if="$route.name === names.MAIN"
        :name_list='left_menu_list'
    ></Main>
    <router-view v-else></router-view>
  </div>
</template>

<script>

import names from "@/modules/entitled/routers/names"
import Main from "./Main";
import {getInstMenu, getInstNameByRouterName} from "@/helper/instances";
import PageHeader from "../menus/PageHeader";
import {mapActions, mapGetters} from "vuex";
import url from "@/urls/roles/entitled";
import {checkIsDevelopmentServer} from "@/helper";

export default {
  name: "RepresentativeBase",
  // eslint-disable-next-line vue/no-reserved-component-names
  components: {Main, PageHeader},
  data(){
    return {
      left_menu_list: [
        // {title: 'Главная', icon: 'home', included: false, router: {name:  names.MAIN, params:{}}},
        {title: "Заявки", icon: "grading", color: "#90CAF9", included: true, router: {name:  names.ORDERS.LIST, params:{}}},
        {title: "Список нарушений", icon: "car_crash", included: true, color: "#eab676", router: {name: names.FOULS.LIST, params:{}}},
        {title: "Заблокированные пользователи", icon: "no_accounts", included: true, color: "#eab676", router: {name: names.BANS.LIST, params:{}}},
        {title: "Посетители", icon: "group", color: "#76b5c5", included: true, router: {name:  names.VISITORS.LIST, params:{}}},
        // {title: 'Доступ охраны', icon: 'shield', included: true, router: {name:  names.GUARD._BASE, params:{}}},
        {
          title: "Настройки", icon: "view_quilt", subs: [
            {title: "Организации", icon: "corporate_fare", color: "#76b5c5", included: true, router: {name: names.ORGANIZATIONS.LIST, params:{}}},
            {title: "Постоянные пропуска", icon: "local_activity", color: "#76b5c5", included: true, router: {name: names.REGULAR_PASSES.LIST, params:{}}},
            {title: "Посты охраны", icon: "camera_outdoor", color: "#76b5c5", included: true, router: {name: names.GUARD_POSTS.LIST, params:{}}},
          ]
        },
      ]
    }
  },
  computed: {
    names: () => names,
    ...mapGetters({
      isAuthenticated: "user/isAuthenticate",
      isMobileView: "isMobileView"
    })
  },
  methods: {
    ...mapActions({
      connectJWT: "eventchain/connectJWT",
      initEvent: "eventchain/initEvent"
    }),
    checkIsDevelopmentServer: checkIsDevelopmentServer,
    loadLeftmenu() {
      this.$store.commit("mainpage/changeTitle", "Согласующий");
      if (this.isAuthenticated) {
        let instMenu = this.getLeftMenu();
        if (!url.ENTITLED.ROLES.BANS.ALLOWED())
          instMenu.splice(2,1)
        this.$store.commit("leftmenu/replaceInstances", getInstMenu());
        this.$store.commit("leftmenu/selectInstance", getInstNameByRouterName(names.ORDERS.LIST));
        this.$store.commit("leftmenu/replaceItems", instMenu);
      } else {
        this.$store.commit("leftmenu/dissable");
      }
    },
    getLeftMenu() {
      let menu = []
      for (let el in this.left_menu_list){
        menu.push(this.left_menu_list[el])
      }
      return menu
    }
  },
  beforeRouteUpdate(to, from, next) {
    this.loadLeftmenu()
    next()
  },
  created() {
    if (this.isAuthenticated) {
      this.$store.commit("leftmenu/enableLeftMenu");
      if (!this.isMobileView) this.$store.commit("leftmenu/showLeftMenu");
    }
    if (checkIsDevelopmentServer()) {
      this.connectJWT({
        finalizer: () => {
          this.initEvent({})
        }
      })
    }
    this.loadLeftmenu()
  }
}
</script>

<style scoped>

</style>
